import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Response } from '../../../shared/models/response.model';
import { Aptitude } from './models/aptitude.model';
import { AptitudeCreateRequest } from './requests/create-request';
import { AptitudeUpdateRequest } from './requests/update-request';

@Injectable({
  providedIn: 'root',
})
export class ProcessusAptitudeService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/aptitudes`;

  findAll(idCartographie: string, nom?: string, idRéférentiel?: string) {
    let params = new HttpParams().append('idCartographie', idCartographie);

    if (idRéférentiel) params = params.append('idReferentiel', idRéférentiel);
    if (nom) params = params.append('nom', nom);

    return this.#http.get<Response<Aptitude>>(this.BASE_URL, { params });
  }

  findById(idAptitude: string): Observable<Aptitude> {
    return this.#http.get<Aptitude>(this.BASE_URL + '/' + idAptitude);
  }

  créer = (data: AptitudeCreateRequest) => this.#http.post<Aptitude[]>(this.BASE_URL, data);

  modifier = (idAptitude: string, data: AptitudeUpdateRequest) =>
    this.#http.put<{ path: string }>(this.BASE_URL + '/' + idAptitude, data);

  supprimer(idAptitude: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + idAptitude);
  }
}
